import {useQuery} from "@tanstack/react-query";
import {apiGetSharedModule} from "../../../data/api/sharedModule";

export const useGetSharedModule = (module,uuid, config) => {
    return useQuery({
        queryKey: ['share', 'module'],
        queryFn: () => apiGetSharedModule(module, uuid),
        ...config,
    })
}